import { PotentialBooking } from '@sales-app/graphql/queries/potentialBooking/potentialBookings.queries'
import { Source } from '@sales-app/graphql/queries/potentialBooking/source.queries'
import { Status } from '@sales-app/graphql/queries/potentialBooking/status.queries'
import { BookingAgent } from '@sales-app/types/Agent'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { DisplayCity } from '@sales-app/types/DisplayCity'

export interface WorkspaceState {
  activeTabId: number | null
  activeTabType: BookablePersonType | null
  recentlyClosedTabs: WorkspaceTab[]
  tabs: WorkspaceTab[]
}

export interface BookablePerson {
  bookablePersonId: number
  bookablePersonType: BookablePersonType
}

export interface WorkspaceTab extends BookablePerson {
  label: string
  lastAccessedTime: Date
  potentialBooking: PotentialBooking | null
  potentialBookingFilters: HomeFilters | null
  potentialBookingId: number | null
  userId?: number | null
  view: WorkspaceView
}

export enum WorkspaceView {
  POTENTIALBOOKING = 'potential-booking',
  SUMMARY = 'summary',
}

export interface WorkspaceAction {
  filters?: Partial<HomeFilters>
  state?: WorkspaceState
  tab?: WorkspaceTab
  type: string
}

export interface HomeFilters extends GeoCoordinates {
  agent?: BookingAgent | null
  amenity?: string[]
  baths?: number[]
  beds?: number[]
  createdAt?: string
  currentPage?: number
  displayCity?: DisplayCity
  displayCityId?: number
  listView: boolean
  maxPrice?: string
  minPrice?: string
  moveInEndDate?: Date
  moveInStartDate?: Date
  moveOutEndDate?: Date
  moveOutStartDate?: Date
  notes?: string
  pending?: boolean
  potentialCompetitors?: PotentialCompetitors[]
  reservationType?: string
  source?: Source
  status?: Status
  utmSource?: string
}

export interface GeoCoordinates {
  neLatitude?: string
  neLongitude?: string
  swLatitude?: string
  swLongitude?: string
}

export enum PotentialCompetitors {
  Airbnb = 'Airbnb',
  Blueground = 'Blueground',
  Hotels = 'Hotels',
  Other = 'Other',
  Sonder = 'Sonder',
  UnfurnishedApartments = 'UnfurnishedApartments',
  Vrbo = 'Vrbo',
  ZeusLiving = 'ZeusLiving',
}
